import { TranslationKeys } from '~frontend-common/i18n/english/driving-convictions-subquestions.i18n';

const keys: TranslationKeys = {
  drivingConvictions: {
    actions: {
      add: 'Ajouter une contravention',
      edit: 'Modifier',
      remove: 'Supprimer',
    },
    title:
      "Ajoutez toutes les contraventions pour lesquelles vous avez été sanctionné sauf les constats d'infraction de stationnement.",
    fields: {
      convictionYear: 'Année de la contravention',
      convictionDescription: 'Motif de la contravention',
      speedConviction: {
        specificDriver: '{{0}} a-t-il dépassé la limite de vitesse permise de 50km/hr ou plus?',
        default: 'Avez-vous dépassé la limite de vitesse permise de 50km/hr ou plus?',
      },
    },
    placeholders: {
      convictionYear: 'ex. 2019',
      convictionDescription: 'ex. Excès de vitesse',
    },
  },
};

export default keys;
